export enum SIGNUP_TYPE {
  EMAIL = 'email',
  FACEBOOK = 'facebook',
  UNTRACKED = 'untracked'
}
